export enum LocalStorageKeys {
    DraftUserId = 'draftUserId',
    EmojiIds = 'emojiIds',
    FirstTimeUserExperience = 'ftue',
    OAuthLoggedIn = 'OAuthLoggedIn',
    RemoveDraftUser = 'removeDraftUser',
}

export enum LocalStorage2FAKeys {
    TimeSinceRequire = 'time_since_require_prompt',
    TimeSincePostPurchase = 'time_since_post_purchase_prompt',
}
